var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVehiclesOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dispatch-1",
    transform: "translate(-22.000000, -713.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_vehicles",
    transform: "translate(20.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_licenseplate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99,12.49 L15.89,12.49",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.02,9.49 L18.98,9.49",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 2,
    points: "12 16.28 12 16.28 16.92 16.28 16.92 17.98 20.59 17.98 21 17.98 21 10.79 19.03 9.47 17.26 6.02 12 6.02 12 6.02 12 6.02 6.74 6.02 4.97 9.47 3 10.79 3 17.98 3.41 17.98 7.08 17.98 7.08 16.28 12 16.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1,12.49 L20.94,12.49",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06,12.49 L6.9,12.49",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,12.49 L15,12.49",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVehiclesOrange);
export default __webpack_public_path__ + "static/media/ico_vehicles_orange.0d07740dd25295fee4b0ce327477aff8.svg";
export { ForwardRef as ReactComponent };